import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as FeatureFlagReducer from './featureFlags.reducer';
import * as _ from 'lodash';
import { getGlobalBackupLocationFeatureFlags, getGlobalLocationFeatureFlags } from '../partner/partner.selectors';

export const stateFeature = createFeatureSelector<FeatureFlagReducer.State>(
  FeatureFlagReducer.featureFlagTemplatesFeatureKey
);

export const getFeatureFlags = createSelector(
  stateFeature,
  (state: FeatureFlagReducer.State) =>
    _.toArray(_.get(state, ['templates_feature_flags'], undefined))
);
export const getLocation = (props: { feature_flag_template_uuid: string }) =>
  createSelector(stateFeature, (state: FeatureFlagReducer.State) =>
    _.get(
      state,
      ['templates_feature_flags', props.feature_flag_template_uuid],
      undefined
    )
  );
export const getDefault = createSelector(
  stateFeature,
  getFeatureFlags,
  (state: FeatureFlagReducer.State, featureFlags) =>
    _.find(featureFlags, { is_default: true })
);
export const getDefaultFull = createSelector(
  stateFeature,
  getFeatureFlags,
  (state: FeatureFlagReducer.State, featureFlags) =>
    _.get(state, ['default_feature_flag'], undefined)
);
export const getDefaultLocationFeatureFlagsFull = createSelector(
  stateFeature,
  getGlobalLocationFeatureFlags,
  (state: FeatureFlagReducer.State, partnerLocations) => {
    const localLocationFF = _.filter(
      _.get(state, ['default_feature_flag'], { values: [] }).values,
      (_feature) => {
        return _feature.name.search('location_access') >= 0;
      }
    );

    return _.unionBy(
      localLocationFF,
      partnerLocations as unknown as any,
      'name'
    );
  }
);
export const getDefaultBackupLocationFeatureFlagsFull = createSelector(
  stateFeature,
  getGlobalBackupLocationFeatureFlags,
  (state: FeatureFlagReducer.State, partnerLocations) => {

    const localLocationFF = _.filter(
      _.get(state, ['default_feature_flag'], { values: [] }).values,
      (_feature) => {
        return _feature.name.search('backup_location') >= 0;
      }
    );

    return _.unionBy(
      localLocationFF,
      partnerLocations as unknown as any,
      'name'
    );
  }
);

export const canDisableLocations = createSelector(
  getDefaultLocationFeatureFlagsFull,
  (defaultLocationFeatureFlags) => {
    let activeLocations = 0;

    defaultLocationFeatureFlags.forEach((ff) =>
      ff.value === true ? activeLocations++ : null
    );

    return activeLocations > 1;
  }
);

export const isFeatureFlagsLoading = createSelector(
  stateFeature,
  (state: FeatureFlagReducer.State) => _.get(state, ['loading'], false)
);

export const isFeatureFlagsLoaded = createSelector(
  stateFeature,
  (state: FeatureFlagReducer.State) => _.get(state, ['loaded'], false)
);
